module.exports = __webpack_public_path__ + "img/yt.9928275d.svg";